import React from "react";
import CustomerComponent from "../../components/customerManagementComponents/CustomerComponent";
import HeaderComponent from "../../components/common/HeaderSectionComponent";
import {
  CardAllCustomer,
  CircleNumber,
  Container,
  ContainerCard,
  ContainerCustomer,
  HeaderCardAllCustomer,
  HeaderDivCardAllCustomer,
  MainContainerCard,
  SelectSection,
} from "./index.style";
import CustomerCard from "../../components/customerManagementComponents/CustomerCard";
import ModalCustomer from "../../components/customerManagementComponents/ModalCustomer";
import { Spinner } from "react-rainbow-components";
import ModalPets from "../../components/common/ModalPets";
import useCustomerManagementPage from "./useCustomerManagementPage";

export default function CustomerManagementPage() {
  const {
    customerData,
    ToggleToShow,
    showArrow,
    isLoading,
    showCardCustomer,
    ToggleModal,
    handleShowModalPets,
    fetchData,
    showModal,
    isShowModelPets,
    dataModalPets,
    setIsShowModelPets,
  } = useCustomerManagementPage();

  const CustomerMapping = customerData.map((item, index: number) => {
    return (
      <CustomerComponent
        key={index}
        customer={item}
        Toggle={() => ToggleToShow(index)}
        show={showArrow === index}
      />
    );
  });

  return (
    <Container>
      <div style={{ padding: "2rem", paddingBottom: 0 }}>
        {HeaderComponent({
          title: "Customer Management",
          subheader: "ระบบบริหารจัดการลูกค้า",
        })}
      </div>
      <SelectSection>
        {isLoading ? (
          <Spinner />
        ) : (
          <>
            <ContainerCustomer>
              <HeaderDivCardAllCustomer>
                <HeaderCardAllCustomer>
                  ลูกค้าในระบบตอนนี้
                </HeaderCardAllCustomer>
                <CircleNumber>
                  {customerData.length > 99 ? "99+" : customerData.length}
                </CircleNumber>
              </HeaderDivCardAllCustomer>
              <CardAllCustomer>{CustomerMapping}</CardAllCustomer>
            </ContainerCustomer>
            <MainContainerCard>
              <ContainerCard flexdisplay={showCardCustomer !== -1}>
                {showCardCustomer !== -1 ? (
                  <>
                    <CustomerCard
                      dataCustomer={customerData[showCardCustomer]}
                      ToggleShow={() => ToggleModal(showModal)}
                      onClickShowPets={handleShowModalPets}
                    />
                    <ModalCustomer
                      customer={customerData[showCardCustomer]}
                      ToggleClose={() => ToggleModal(showModal)}
                      isOpen={showModal}
                      refashData={fetchData}
                    />
                  </>
                ) : null}
              </ContainerCard>
            </MainContainerCard>
          </>
        )}
      </SelectSection>
      <ModalPets
        isOpen={isShowModelPets}
        setIsOpen={setIsShowModelPets}
        data={dataModalPets}
      />
    </Container>
  );
}
